import {Button, Center, Stack, Text, Title, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ModelHubDesktopPromptProps {
  onContinue: () => void;
}

const TITLE_ID = 'model-hub-desktop-prompt-title';
const CONTENT_MAX_WIDTH_PX = 480;
const ICON_TILE_SIZE_PX = 68;

export default function ModelHubDesktopPrompt({onContinue}: ModelHubDesktopPromptProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Center aria-labelledby={TITLE_ID} className={classes.root} component="main" h="100vh" p="xl">
      <Stack align="center" className={classes.content} spacing={24}>
        <Center className={classes.iconTile}>
          <BenchlingIcon aria-hidden={true} className={classes.icon} icon="hexagon-nodes" />
        </Center>
        <Stack align="center" spacing={8}>
          <Title className={classes.title} id={TITLE_ID} order={1} size="h3">
            Model Hub works best on desktop
          </Title>
          <Text className={classes.description}>
            Open Model Hub on a desktop to view and manage predictions
          </Text>
        </Stack>
        <Button onClick={onContinue} radius="xl" variant="ghost">
          Continue anyway
        </Button>
      </Stack>
    </Center>
  );
}

const useStyles = createStyles((theme) => ({
  root: {
    backgroundColor: theme.white,
  },
  content: {
    maxWidth: CONTENT_MAX_WIDTH_PX,
    width: '100%',
  },
  description: {
    color: theme.colors.gray[7],
    fontSize: theme.fontSizes.md,
    lineHeight: 1.5,
    textAlign: 'center',
  },
  icon: {
    color: theme.colors.gray[7],
    fontSize: 26,
  },
  iconTile: {
    backgroundColor: theme.colors.gray[1],
    borderRadius: theme.radius.lg,
    height: ICON_TILE_SIZE_PX,
    width: ICON_TILE_SIZE_PX,
  },
  title: {
    color: theme.black,
    fontWeight: 600,
    lineHeight: 1.4,
    textAlign: 'center',
  },
}));
